import fetch from 'cross-fetch';
import tokenConfig from './config/tokenConfig';
import LightSpeedAuto from './config/lightSpeedAutio';
import { baseUrl } from '../Constants/environment';
import driverSchema from '../Driver/store';
import vehicleSchema from '../Vehicle/store';
import historySchema from '../History/store';
import moment from 'moment';
import 'url-search-params-polyfill';

/**
 * 
 * @param {*} data 
 */
export const loadStartQuote = (data) => {
    return {
        type: 'LOAD_START_QUOTE_DATA',
        payload: data,
        "credentials": "include",
        "method": "POST",
        "headers": {
            "Authorization": "Basic MjhTb2x1dGlvbnNVQVRBUEk6QXJ4OSRSMlpZViN4VWpDcA==",
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            "Accept": "application/json",
        }
    }
}

/**
 * getToken: retrieves a token from our token service at the begining of the application
 */
export const getToken = () => {

    let formData = prepareFormData({
        grant_type: "client_credentials"
    });

    tokenConfig.body = formData.toString();

    console.log(formData);
    console.log(tokenConfig);

    const promise = new Promise((resolve, reject) => {
        resolve(tokenConfig);
    });



    return (dispatch) => {
        dispatch(retrievingToken());
        promise.then(data => {
            console.log(data);
            console.log(tokenConfig);
            fetch(`${baseUrl}/token`, tokenConfig).then((response) => {
                return response.json();
            }).then((myData) => {
                dispatch(recievedToken(myData));
            });
        }).catch(err => {
            console.log(err);
        })

    }

    /*
    return (dispatch) => {
        axios({
            method: 'post',
            url: 'https://gatewayuat.verisk.com/token',
            data: formData,
            "credentials": "include",
            "method": "POST",
            "headers": {
                "Authorization": "Basic MjhTb2x1dGlvbnNVQVRBUEk6QXJ4OSRSMlpZViN4VWpDcA==",
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "Accept": "application/json",
            }
        })
            .then(function (response) {
                //handle success
                console.log(response);
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });

    };
    */
}

/**
 * 
 * @param {*} params : this should be an object 
 */
const prepareFormData = (params) => {

    let formData = new URLSearchParams();

    for (let k in params) {
        formData.append(k, params[k]);
    }

    return formData;
}

/**
 * 
 * @param {*} token : this should be the token recieved from the token service
 */
export const recievedToken = (token) => {
    console.log(token);
    return {
        type: 'RECEIVED_TOKEN',
        payload: token
    }
}

export const emptyToken = () => {
    //console.log(token);
    return {
        type: 'RECEIVED_TOKEN',
        payload: null
    }
}

/**
 * this allows us to let the UI know that we are still retrieving a token.
 */
const retrievingToken = () => {
    return {
        type: 'RETRIEVING_TOKEN'
    }
}

/**
 * 
 * @param {*} token 
 * @param {*} formValues 
 */
export const getUnderWriting = (token, formValues) => {
    console.log(formValues);

    let myInit = LightSpeedAuto.getConfig();

    formValues.Addresses[0].AddressType = "Current";

    myInit.headers.Authorization = "Bearer " + token;
    return dispatch => {
        dispatch({
            type: 'REQUESTING_UNDERWRITING'
        });
        return fetch(`${baseUrl}/underwriting/lightspeed/prefill/auto/v1`, {
            "method": "POST",
            "headers": {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            "body": JSON.stringify({
                "Header": {
                    "Authorization": {
                        "OrgId": "101506",
                        "ShipId": "101506"
                    },
                    "QuoteBack": "Quoteback001"
                },
                Body: formValues
            })
        })
            .then(handleErrors)
            .then((response) => {
                console.log(response);
                if (response.status === 200){
                    return response.json();
                }
                else{
                    return response.json();
                }
            })
            .then((data) => {
                console.log(data);
                //body.completeQuote
                data.body.completeQuote.subjects = updateDrivers(data.body.completeQuote.subjects);
                data.body.completeQuote.vehicles = updateVehicles(data.body.completeQuote.vehicles);
                if (data.body.completeQuote.policies) {
                    data.body.completeQuote.History = setHistory(data.body.completeQuote.policies[0]);
                }
                else {
                    data.body.completeQuote.History = {
                        ...historySchema
                    };
                }
                console.log(data, 'new data');
                dispatch({
                    type: 'RECEIVED_UNDERWRITING',
                    payload: {
                        underwriting: data,
                        quoteStarted: true
                    }
                });
                return data;
            }).catch((err, response) => {
                console.log(err);
                return err;
                /*
                dispatch({
                    type: 'RECEIVED_UNDERWRITING_ERROR',
                    payload: {
                        error: err,
                        quoteStarted: true
                    }
                });
                */
            });
    }
}

/**
 * 
 * @param {*} response 
 */
const handleErrors = (response) => {
    console.log(response);
    console.log(response.status);
    if (!response.ok) {
        throw Error(JSON.stringify(response));
    }   
    return response;
}

export const savePolicyHolderName = (name) => {
    return {
        type: 'SAVE_POLICYHOLDER_NAME',
        payload: name
    }
}

export const populateUnderWriting = (data) => {
    console.log(data);
    //data.underwriting.body.completeQuote.subjects
    //
    data.subjects = updateDrivers(data.body.completeQuote.subjects);
    data.vehicles = updateVehicles(data.body.completeQuote.vehicles);
    data.History = setHistory(data.body.completeQuote.policies[0]);

    return {
        type: 'RECEIVED_UNDERWRITING',
        payload: {
            underwriting: data,
            quoteStarted: true
        }
    }
}

const updateDrivers = (drivers) => {
    let updatedDrivers = [];
    drivers.forEach((element) => {

        console.log(setGender(element.gender));

        updatedDrivers.push({
            ...driverSchema,
            ...element,
            dob: {
                dobPrimarySource: setDOBPrimary(element.dob)
            },
            gender: {
                genderPrimarySource: setGender(element.gender)
            }

            //...maritalStatus
        });
    });

    console.log(updatedDrivers, 'new drivers');
    return updatedDrivers;
}

const updateVehicles = (vehicles) => {
    let updatedVehicles = [];
    if (vehicles) {
        vehicles.forEach((vehicle) => {
            //let vehicleNew = Object.assign(vehicleSchema, vehicle);

            //const newVehicle = Object.assign(vehicleSchema, vehicle);
            //vehicle.chrisTest = 'testing';
            updatedVehicles.push({
                ...vehicleSchema,
                ...vehicle
            });
            //updatedVehicles.push(vehicleNew);
        });
    }
    return updatedVehicles;
}

function setDOBPrimary(dob) {
    console.log(dob);
    if (dob === undefined) {
        return null;
    }
    if (dob.dobPrimarySource) {
        return dob.dobPrimarySource;
    }
    else if (dob.dobSecondarySource) {
        return dob.dobSecondarySource.dob;
    }
    return null;
}

function setGender(gender) {
    console.log(gender);
    if (gender) {
        if (gender.genderPrimarySource) {
            return gender.genderPrimarySource;
        }
        else if (gender.dobSecondarySource) {
            return gender.genderSecondarySource;
        }
    }
    return null;
}

function setHistory(history) {
    console.log(history);
    return {
        ...historySchema,
        ...history
    };
}

export const loadTestData = (data) => {
    data.DOB = moment(data.DOB, 'YYYY,MM,DD').format('MM/DD/YYYY');
    //
    return {
        type: 'LOAD_FORM',
        payload: data
    }
}

export const isHappyPath=(boolean) => {
    return {
        type:'SET_HAPPY_PATH',
        payload: boolean
    }
}

export const sessionTimedOut = () =>{
    return {
        type: 'SESSION_TIMEOUT',
        payload: true
    }
}


// WEBPACK FOOTER //
// ./src/StartQuote/actions.js